import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info",
  "data-testid": "infoId"
}
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "info infoDelivery" }
const _hoisted_4 = { class: "infoDelivery-item" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { class: "infoDelivery-item" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.activePickupBox.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('id')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.activePickupBox.id), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPickupBox, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (
        _ctx.activePickupBox.info[item.value] || _ctx.activePickupBox.info[item.value2]
      )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "info",
              "data-testid": item.dataTestid
            }, [
              _createElementVNode("p", null, _toDisplayString(item.label), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.getValue(
            item.dataTestid,
            _ctx.activePickupBox.info[item.value],
            _ctx.activePickupBox.info[item.value2]
          )), 1)
            ], 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('basicLocker')), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoDeliveryRulesBasicLocker, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (_ctx.activePickupBox.info.deliveryRulesBasicLocker[item.value])
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "content-info",
                    "data-testid": item.dataTestid
                  }, [
                    _createElementVNode("p", null, _toDisplayString(item.label), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.msToDays(
                  _ctx.activePickupBox.info.deliveryRulesBasicLocker[item.value]
                )), 1)
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('fridgeLocker')), 1),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoDeliveryRulesFridgeLocker, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (_ctx.activePickupBox.info.deliveryRulesFridgeLocker[item.value])
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "content-info",
                    "data-testid": item.dataTestid
                  }, [
                    _createElementVNode("p", null, _toDisplayString(item.label), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.msToDays(
                  _ctx.activePickupBox.info.deliveryRulesFridgeLocker[item.value]
                )), 1)
                  ], 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoIntervalTime, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (_ctx.activePickupBox.info[item.value])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "info",
              "data-testid": item.dataTestid
            }, [
              _createElementVNode("p", null, _toDisplayString(item.label), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.msToMin(_ctx.activePickupBox.info[item.value])), 1)
            ], 8, _hoisted_12))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 64))
}